import React from "react";
import { useGoogleLogin } from "@react-oauth/google";

/**
 * "Continue with Google" button — custom Google OAuth (Authorization Code flow,
 * redirect UX). Google returns the user to <origin>/auth/google?code=..., which
 * is handled by GoogleCallback.jsx.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleAuthButton({
  label = "Continue with Google",
  testid = "google-auth-btn",
}) {
  // Build the redirect_uri from window.location.origin at render time so
  // preview and production each get their correct host without env vars.
  const redirectUri = typeof window !== "undefined"
    ? `${window.location.origin}/auth/google`
    : undefined;

  const login = useGoogleLogin({
    flow: "auth-code",
    ux_mode: "redirect",
    redirect_uri: redirectUri,
    // Library defaults already request openid+email+profile — no scope override needed.
  });

  return (
    <button
      type="button"
      onClick={() => login()}
      data-testid={testid}
      className="w-full py-3 rounded-md font-semibold text-sm bg-white text-black hover:bg-white/90 transition-colors inline-flex items-center justify-center gap-2.5"
    >
      <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
        <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
        <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
        <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
      </svg>
      {label}
    </button>
  );
}
